import component from './zh-TW/component';
import globalHeader from './zh-TW/globalHeader';
import menu from './zh-TW/menu';
import pages from './zh-TW/pages';
import pwa from './zh-TW/pwa';
import settingDrawer from './zh-TW/settingDrawer';
import settings from './zh-TW/settings';
import memberList from './zh-TW/memberList';
import dashboard from './zh-TW/dashboard';
import register from './zh-TW/register';
import staff from './zh-TW/staff';
import store from './zh-TW/store';

export default {
  'navBar.lang': '語言',
  'layout.user.link.help': '幫助',
  'layout.user.link.privacy': '隱私',
  'layout.user.link.terms': '條款',
  'app.copyright.produced': '藍海科技工作室出品',
  'app.preview.down.block': '下載此頁面到本地項目',
  'app.welcome.link.fetch-blocks': '獲取全部區塊',
  'app.welcome.link.block-list': '基於 block 開發，快速構建標準頁面',
  ...pages,
  ...globalHeader,
  ...menu,
  ...settingDrawer,
  ...settings,
  ...pwa,
  ...component,
  ...memberList,
  ...dashboard,
  ...register,
  ...staff,
  ...store,
  'pages.403.subTitle': '抱歉，您沒有訪問此頁面的權限。',
  'pages.403.back': '返回首頁',
  'menu.account.logout': '退出登錄',
  'menu.account.logout.confirm': '確認退出登錄',
  'menu.account.logout.confirm.content': '您確定要退出登錄嗎？',
  'menu.account.logout.success': '已成功退出登錄',
  'menu.account.logout.failed': '退出登錄失敗',
  
  'menu.account.changePassword': '修改密碼',
  'menu.account.changePassword.currentPassword': '當前密碼',
  'menu.account.changePassword.currentPassword.required': '請輸入當前密碼',
  'menu.account.changePassword.newPassword': '新密碼',
  'menu.account.changePassword.newPassword.required': '請輸入新密碼',
  'menu.account.changePassword.password.tooShort': '密碼長度不能少於6個字符',
  'menu.account.changePassword.confirmPassword': '確認新密碼',
  'menu.account.changePassword.confirmPassword.required': '請確認新密碼',
  'menu.account.changePassword.passwordMismatch': '兩次輸入的密碼不一致',
  'menu.account.changePassword.success': '密碼修改成功',
  'menu.account.changePassword.failed': '密碼修改失敗',
  'menu.account.changePassword.incorrectPassword': '當前密碼不正確',
  'pages.memberList.pagination.total': '共 {total} 條記錄',
  'pages.memberList.pagination.pageSize': '條/頁',
  'pages.memberList.pagination.jump': '跳至',
  'pages.memberList.pagination.page': '頁',
  
  // 禮品卡列表
  'pages.giftCardList.title': '禮品卡列表',
  'pages.giftCardList.create': '創建禮品卡',
  'pages.giftCardList.createVirtual': '創建虛擬禮品卡',
  'pages.giftCardList.createPhysical': '創建實體禮品卡',
  'pages.giftCardList.downloadPhysical': '批量下載實體卡號',
  'pages.giftCardList.code': '禮品卡編號',
  'pages.giftCardList.physicalCardNumber': '實體卡號',
  'pages.giftCardList.value': '禮品卡面值',
  'pages.giftCardList.initialAmount': '初始金額',
  'pages.giftCardList.balance': '剩餘餘額',
  'pages.giftCardList.balanceStatus': '餘額',
  'pages.giftCardList.balanceStatus.all': '全部禮品卡',
  'pages.giftCardList.balanceStatus.withBalance': '有餘額',
  'pages.giftCardList.balanceStatus.withoutBalance': '無餘額',
  'pages.giftCardList.status': '狀態',
  'pages.giftCardList.createTime': '創建時間',
  'pages.giftCardList.activeDate': '激活日期',
  'pages.giftCardList.activeBy': '激活人',
  'pages.giftCardList.activationStatus': '激活狀態',
  'pages.giftCardList.activationStatus.all': '全部禮品卡',
  'pages.giftCardList.activationStatus.active': '已激活',
  'pages.giftCardList.activationStatus.inactive': '未激活',
  'pages.giftCardList.expiryDate': '到期日期',
  'pages.giftCardList.validDays': '有效期（天）',
  'pages.giftCardList.actions': '操作',
  'pages.giftCardList.actions.details': '詳情',
  'pages.giftCardList.note': '備註',
  'pages.giftCardList.date': '日期範圍',
  'pages.giftCardList.refresh': '刷新',
  'pages.giftCardList.email': '電子郵箱',
  'pages.giftCardList.phone': '手機號碼',
  'pages.giftCardList.tempEmail': '臨時電子郵箱',
  'pages.giftCardList.tempPhone': '臨時手機號碼',
  'pages.giftCardList.contactInfo': '聯繫方式',
  'pages.giftCardList.search.infoType.placeholder': '請選擇聯繫方式',
  'pages.giftCardList.contactValue': '聯繫資訊',
  'pages.giftCardList.search.infoValue.placeholder': '請輸入聯繫資訊',
  'pages.giftCardList.createDate': '創建日期',
  
  'pages.giftCardList.search.code.placeholder': '請輸入禮品卡編號',
  'pages.giftCardList.search.cardNumber': 'Card ID / 實體卡號',
  'pages.giftCardList.search.status.placeholder': '請選擇狀態',
  'pages.giftCardList.search.date.start': '開始日期',
  'pages.giftCardList.search.date.end': '結束日期',
  'pages.giftCardList.search.submit': '搜索',
  'pages.giftCardList.search.reset': '重置',
  
  'pages.giftCardList.create.success': '禮品卡創建成功',
  'pages.giftCardList.create.error': '禮品卡創建失敗',
  'pages.giftCardList.create.value.required': '請輸入禮品卡面值',
  'pages.giftCardList.create.value.placeholder': '請輸入禮品卡面值',
  'pages.giftCardList.create.balance.required': '請輸入初始餘額',
  'pages.giftCardList.create.balance.placeholder': '請輸入初始餘額',
  'pages.giftCardList.create.initialAmount.required': '請輸入初始金額',
  'pages.giftCardList.create.initialAmount.placeholder': '請輸入初始金額',
  'pages.giftCardList.create.email.placeholder': '請輸入電子郵箱',
  'pages.giftCardList.create.phone.placeholder': '請輸入手機號碼',
  'pages.giftCardList.create.expiryDate.placeholder': '請選擇到期日期',
  'pages.giftCardList.create.validDays.required': '請輸入有效天數',
  'pages.giftCardList.create.validDays.placeholder': '請輸入有效天數',
  'pages.giftCardList.create.note.placeholder': '請輸入備註信息',
  'pages.giftCardList.physical.issuingStore': '發卡門店',
  'pages.giftCardList.physical.storeRequired': '請選擇發卡門店',
  'pages.giftCardList.physical.quantity': '數量',
  'pages.giftCardList.physical.batch': '創建批次',
  'pages.giftCardList.physical.allBatches': '全部實體禮品卡',
  'pages.giftCardList.physical.loadError': '載入實體禮品卡選項失敗',
  'pages.giftCardList.physical.createSuccess': '已創建 {count} 張實體禮品卡',
  'pages.giftCardList.physical.createError': '創建實體禮品卡失敗',
  'pages.giftCardList.physical.batchLoadError': '載入實體禮品卡批次失敗',
  'pages.giftCardList.physical.downloadError': '下載實體卡號失敗',
  
  'pages.giftCardList.level': '禮品卡類型',
  'pages.giftCardList.create.level.required': '請選擇禮品卡類型',
  'pages.giftCardList.create.level.placeholder': '請選擇禮品卡類型',
  'pages.giftCardList.error.headOffice': '無法獲取總部信息',
  'pages.giftCardList.error.fetchLevels': '獲取禮品卡類型失敗',
  'pages.giftCardList.error.storeId': '未找到門店ID',
  'pages.giftCardList.error.invalidStoreId': '門店ID格式不正確',
  'pages.giftCardList.error.fetchFailed': '獲取禮品卡列表失敗',
  'pages.giftCardList.error.fetchStoreFailed': '獲取門店信息失敗',
  'pages.giftCardList.error.noLevels': '未找到禮品卡等級配置，請先在管理後台創建禮品卡等級',
  
  'pages.giftCardList.status.active': '激活',
  'pages.giftCardList.status.inactive': '未激活',
  'pages.giftCardList.status.expired': '已過期',
  'pages.giftCardList.status.used': '已使用',
  'pages.giftCardList.status.cancelled': '已取消',
  
  'pages.giftCardList.pagination.total': '共 {total} 條記錄',
  'pages.giftCardList.pagination.pageSize': '條/頁',
  'pages.giftCardList.pagination.jump': '跳至',
  'pages.giftCardList.pagination.page': '頁',
  
  'app.common.cancel': '取消',
  'app.common.create': '創建',
  'pages.store.giftCardDetails.send.email': '發送郵件',
  'pages.store.giftCardDetails.send.phone': '發送簡訊',
  'pages.store.giftCardDetails.send.card': '發送卡片',
  'pages.store.giftCardDetails.send.wallet': '發送到錢包',
  'pages.store.giftCardDetails.email.placeholder': '請輸入電子郵箱',
  'pages.store.giftCardDetails.phone.placeholder': '請輸入手機號碼',

  // Additional translations for messages and missing labels.
  'app.common.request.error': '請求失敗，請重試',
  'app.common.request.noResponse': '伺服器未回應，請重試',
  'pages.store.giftCardDetails.email.invalid': '請輸入有效的郵箱地址',
  'pages.store.giftCardDetails.expiry.placeholder': '請選擇過期時間',
  'pages.store.giftCardDetails.send.sms.success': '禮品卡簡訊發送成功',
  'pages.store.giftCardDetails.send.email.success': '禮品卡郵件發送成功',
  'pages.store.giftCardDetails.send.error': '禮品卡發送失敗，請重試',
  'pages.store.giftCardDetails.unavailable': '禮品卡資料不存在',
  'pages.store.giftCardDetails.phone.missing': '禮品卡沒有關聯手機號碼',
  'pages.store.giftCardDetails.email.missing': '禮品卡沒有關聯郵箱',
  'pages.store.giftCardDetails.fetch.error': '獲取禮品卡詳情失敗',
  'pages.store.giftCardDetails.edit.success': '修改禮品卡資訊成功',
  'pages.store.giftCardDetails.edit.error': '修改禮品卡資訊失敗',
  'pages.store.memberDetails.send.sms.success': '會員卡簡訊發送成功',
  'pages.store.memberDetails.send.email.success': '會員卡郵件發送成功',
  'pages.store.memberDetails.send.error': '會員卡發送失敗，請重試',
  'pages.store.memberDetails.fetch.error': '獲取會員詳情失敗',
  'pages.store.memberDetails.headOffice.error': '無法獲取總部資訊',
  'pages.store.memberDetails.levels.error': '獲取會員等級列表失敗',
  'pages.store.memberDetails.unavailable': '會員資訊不可用',
  'pages.store.memberDetails.points.modify.success': '修改積分成功',
  'pages.store.memberDetails.points.modify.error': '修改積分失敗',
  'pages.store.voucherDetails.fetch.error': '獲取優惠券詳情失敗',
  'pages.store.voucherDetails.unavailable': '優惠券資訊不可用',
  'pages.store.voucherDetails.edit.success': '優惠券資訊更新成功',
  'pages.store.voucherDetails.edit.error': '優惠券資訊更新失敗',
  'app.common.invalidParams': '參數錯誤',
  'app.common.user.fetch.error': '獲取使用者資訊失敗',
  'account.center.articles': '文章',
  'account.center.applications': '應用',
  'account.center.projects': '專案',
  'account.center.tags': '標籤',
  'account.center.team': '團隊',
  'dashboard.analysis.introduce': '指標說明',
  'dashboard.analysis.action1': '操作一',
  'dashboard.analysis.action2': '操作二',
  'dashboard.analysis.sales': '銷售額',
  'pages.voucherList.modal.fetchMemberLevelsFailed': '獲取會員等級失敗',
  'pages.headOffice.settings.title': '總部設定',
  'memberWelcome.title': '歡迎使用會員卡！',
  'memberWelcome.description': '無論您身在何處，我們都會提供您喜愛的食物。點擊下方圖示新增會員卡。',
  'memberWelcome.viewCard': '查看會員卡',
  'memberWelcome.memberId': '會員 ID',
  'memberWelcome.existing.title': '歡迎回來！',
  'memberWelcome.existing.content': '該手機號碼已註冊，您可以繼續使用會員權益！',
  'memberWelcome.existing.button': '知道了',
  'pages.orderDetails.status.refund': '已退款',
  'pages.orderDetails.status.partiallyRefunded': '部分退款',
  'pages.orderDetails.PointsBalanceAfterTransaction': '交易後積分餘額',
  'pages.orderDetails.cardUsedAmount': '卡片使用金額',
  'pages.orderDetails.BalanceAfterTransaction': '交易後餘額',
  'pages.orderDetails.spentValue': '消費金額',
  'pages.memberList.search.level.placeholder': '選擇會員等級',
  'pages.store.settings.discountRate': '折扣率%',
  'pages.store.settings.memberPriceLevel': '會員價格等級',
  'component.message.success': '操作成功',
  'component.message.failed': '操作失敗',
  'component.message.required': '此項為必填項',
  'pages.login.email.placeholder': '郵箱',
  'memberPortal.profile.resetPassword.success': '密碼重設成功',
  'memberPortal.profile.resetPassword.error': '密碼重設失敗',
  'memberPortal.profile.save.success': '個人資訊更新成功',
  'memberPortal.profile.save.error': '個人資訊更新失敗',
  'memberPortal.profile.email.invalid': '請輸入有效的郵箱地址',
  'memberPortal.profile.mobile.invalid': '手機號碼須以04開頭且為10位數字',
  'memberPortal.profile.verification.sent': '驗證碼發送成功',
  'memberPortal.profile.verification.sendError': '驗證碼發送失敗',
  'memberPortal.profile.phone.updateSuccess': '手機號碼更新成功',
  'memberPortal.profile.phone.updateError': '手機號碼更新失敗',
  'memberPortal.loading.full': '正在載入門市資源…',
  'memberPortal.profile': '個人資訊',
  'memberPortal.profile.points': '目前積分',
  'memberPortal.transactions': '交易紀錄',
  'memberPortal.profile.memberId': '會員 ID',
  'memberPortal.profile.name': '姓名',
  'memberPortal.profile.firstName': '名',
  'memberPortal.profile.middleName': '中間名',
  'memberPortal.profile.lastName': '姓',
  'memberPortal.profile.mobile': '手機號碼',
  'memberPortal.profile.mobile.required': '請輸入手機號碼',
  'memberPortal.profile.mobilePlaceholder': '請輸入手機號碼',
  'memberPortal.profile.email': '郵箱',
  'memberPortal.profile.emailPlaceholder': '請輸入郵箱',
  'memberPortal.profile.ageGroup': '年齡層',
  'memberPortal.profile.ageGroupPlaceholder': '請選擇年齡層',
  'memberPortal.profile.registerTime': '註冊時間',
  'memberPortal.profile.cancel': '取消',
  'memberPortal.profile.save': '儲存',
  'memberPortal.profile.edit': '編輯',
  'memberPortal.profile.logout': '登出',
  'memberPortal.profile.resetPassword': '重設密碼',
  'memberPortal.history.filter': '按日期篩選',
  'memberPortal.history.selectDate': '請選擇日期',
  'memberPortal.history.clearFilter': '清除',
  'memberPortal.history.empty': '暫無交易紀錄',
  'memberPortal.history.store': '門市',
  'memberPortal.history.invoice': '發票',
  'memberPortal.history.status': '狀態',
  'memberPortal.history.reward': '獎勵積分',
  'memberPortal.history.redeem': '兌換積分',
  'memberPortal.history.after': '餘額',
  'memberPortal.history': '歷史紀錄',
  'memberPortal.profile.logout.confirm': '確認登出',
  'memberPortal.profile.logout.message': '登出後將跳轉至註冊頁面。',
  'memberPortal.profile.logout.cancel': '取消',
  'memberPortal.profile.resetPassword.title': '重設密碼',
  'memberPortal.profile.resetPassword.newPassword': '新密碼',
  'memberPortal.profile.resetPassword.newPasswordRequired': '請輸入新密碼',
  'memberPortal.profile.resetPassword.passwordMinLength': '密碼長度須為6至16位',
  'memberPortal.profile.resetPassword.newPasswordPlaceholder': '請輸入新密碼',
  'memberPortal.profile.resetPassword.confirmPassword': '確認密碼',
  'memberPortal.profile.resetPassword.confirmPasswordRequired': '請確認密碼',
  'memberPortal.profile.resetPassword.passwordMismatch': '兩次輸入的密碼不一致',
  'memberPortal.profile.resetPassword.confirmPasswordPlaceholder': '請確認新密碼',
  'memberPortal.profile.resetPassword.cancel': '取消',
  'memberPortal.profile.resetPassword.submit': '重設',
  'memberPortal.profile.phone.verificationTitle': '驗證新手機號碼',
  'memberPortal.profile.phone.newMobile': '新手機號碼',
  'memberPortal.profile.phone.verificationCode': '驗證碼',
  'memberPortal.profile.phone.codeRequired': '請輸入驗證碼',
  'memberPortal.profile.phone.codeLength': '驗證碼須為6位數字',
  'memberPortal.profile.phone.codePlaceholder': '請輸入6位驗證碼',
  'memberPortal.profile.phone.sendCode': '發送驗證碼',
  'memberPortal.profile.phone.resendText': '重新發送驗證碼倒數',
  'memberPortal.profile.phone.resend': '重新發送',
  'memberPortal.profile.phone.cancel': '取消',
  'memberPortal.profile.phone.verify': '驗證',
  'memberPortal.memberCard': '會員卡',
  'pages.login.email.required': '請輸入郵箱',
  'cards.classification.label': '卡片分類',
  'cards.classification.all': '全部分類',
  'cards.classification.virtual': '虛擬卡',
  'cards.classification.physical': '實體卡',
  'cards.classification.physical_virtualized': '實體卡（虛擬化）',
  'cards.classification.physical_virtualized.gift': 'e-giftcard',
  'cards.classification.physical_virtualized.voucher': 'e-voucher',
};
